import * as React from "react";
import { StyleSheet } from "react-native";
import useThemeColor from "../../hooks/useThemeColor";
import Colors from "../../constants/Colors";
import { Feather } from "@expo/vector-icons";
import Text from "../Themed/Text";
import { Placement } from "../../types";
import Pressable from "../Pressable";

type ButtonProps = {
  style?: any;
  lightColor?: string;
  darkColor?: string;
  transparent?: boolean;
  text?: string;
  borderColor?: string;
  textColor?: string;
  icon?: string;
  iconColor?: string;
  iconPlacement?: Placement;
  disabled?: boolean;
  onPress?: () => void;
};

export default function Button(props: ButtonProps) {
  const {
    style,
    lightColor,
    darkColor,
    transparent = false,
    text = "",
    borderColor = Colors.primary_500,
    textColor = Colors.primary_500,
    icon = "",
    iconColor = Colors.base_colors_white,
    iconPlacement = Placement.Left,
    disabled = false,
    onPress,
  } = props;

  const backgroundColor = transparent
    ? "transparent"
    : useThemeColor({ light: lightColor, dark: darkColor }, "background");

  return (
    <Pressable
      onPress={() => !disabled && onPress()}
      style={[
        styles.container,
        style,
        { backgroundColor, borderColor, opacity: disabled ? 0.7 : 1 },
      ]}
      disabled={disabled}
    >
      {icon && iconPlacement == Placement.Left ? (
        <Feather
          style={styles.iconLeft}
          name={icon}
          size={16}
          color={iconColor}
        />
      ) : null}

      {text.length > 0 ? (
        <Text size={16} weight="Bold" lineHeight={20} lightColor={textColor}>
          {text}
        </Text>
      ) : null}

      {icon && iconPlacement == Placement.Right ? (
        <Feather
          style={styles.iconRight}
          name={"arrow-right"}
          size={16}
          color={iconColor}
        />
      ) : null}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 18,
    paddingVertical: 8,
    borderRadius: 100,
    height: 38,
    borderWidth: 2,
  },
  iconLeft: {
    marginRight: 6,
  },
  iconRight: {
    marginLeft: 6,
  },
});
